var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-card',[_c('div',{attrs:{"id":"widget"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }